var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vertical-info-card',{attrs:{"header":"Database","items":_vm.items}})}
var staticRenderFns = []

export { render, staticRenderFns }